export default "__VITE_ASSET__Ch4STSP1__"